module.exports = __webpack_public_path__ + "static/media/grp_ach.514ba3b0.svg";